import Label from 'components/_parts/atoms/label';

function TitleBp({
  child, typeModal, typeTree, datas, t, parentLevel,
}) {
  const mainLabel = {
    update_process: `${t('biz_process.tree.edit')} ${t('biz_process.name')}`,
    add_child: t('biz_process.add_child_bp'),
    add_next: t('biz_process.add_next_bp'),
    add_previous: t('biz_process.add_prev_bp'),
  };

  const addLabelProcess = `${t('biz_process.tree.form.add')} ${t('biz_process.name')}`;

  const colorLabel: { [value: number]: string } = {
    1: 'color_primary',
    2: 'color_steering',
    3: 'color_support',
  };

  const labelBP: { [value: string]: string } = {
    1: 'primary',
    2: 'steering',
    3: 'support',
  };

  const hideLabel = (!typeTree || typeTree === 'update_process') && parentLevel > 1;

  const showLabelProcess = typeTree === 'add_child' || typeTree === 'add_next' || typeTree === 'add_previous';

  return (
    <div className="header_bispro tw-mb-2">
      <div className="label_bispro" style={{ flex: '0 0 60%' }}>
        <Label typeLabel="label_modal">
          { typeTree ? mainLabel[typeTree] : addLabelProcess}
        </Label>
        {!hideLabel && (
        <Label
          className={`label_bispro-type color_primary tw-mt-[5px] ${colorLabel[typeModal]}`}
          typeLabel=""
        >
          {labelBP[typeModal]}
        </Label>
        )}
      </div>
      {showLabelProcess && (
      <div className="tw-mb-2 -tw-mt-[5px]">
        <Label typeLabel="label_modal2">{child.name}</Label>
      </div>
      )}
    </div>
  );
}

export default TitleBp;
